<template>
<div class="container">
  <div class="center">
    <div class="nav-bar">
      <p>
        <span class="parent-link" @click="navToHome()">Admin</span>
        <span> >>> </span>
        <span>Add Account</span>
      </p>
    </div>

    <div class="content">
      <p class="text">Enter username(email)</p>
      <div class="email">
        <input type="text" v-model="account"/>
      </div>

      <div class="check" v-for="(item, index) in checkInfo">
        <input type="checkbox" v-model="item.check"/>
        <span>{{item.text}}</span>
        <div style="clear: both"></div>
      </div>

      <div class="add-btn" @click="addAccount">
        <p>Add Account</p>
      </div>

<!--      <div class="check">-->
<!--        <input type="checkbox" />-->
<!--        <span>EasyPatch Login Account manaement</span>-->
<!--      </div>-->


    </div>
  </div>
</div> <!--container结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    data() {
      return {
        // 'noData':true,
        account:'',
        checkInfo:[
          {
            check:false,
            text:'EasyPatch Login Account management',
            permission:'EasyPatchLogin'
          },
          {
            check:false,
            text:'HCP Account management',
            permission:'HCPCreate'
          },
          {
            check:false,
            text:'Software upgrade product SN management',
            permission:'FirmwareUpdateConfig'
          },
          {
            check:false,
            text:'HCL Function management -PDM',
            permission:'HCLConfig'
          },
           {
            check:false,
            text:'HCL Function management -EasyPatch',
            permission:'HCLConfigForEasyPatch'
          },
          {
            check:false,
            text:'EasyUpdate account management',
            permission:'EasyUpdateLogin'
          },
          {
            check:false,
            text:'User',
            permission:'UserAdmin'
          },
          {
            check:false,
            text:'Agency ',
            permission:'Agency'
          },
        ]
      }
    },
    computed:{

    },
    watch:{

    },
    mounted(){

    },
    methods: {
      addAccount() {
        let permission=[];

        for (let i=0; i<this.checkInfo.length; i++) {
          if (this.checkInfo[i].check) {
            permission.push(this.checkInfo[i].permission)
          }
        }
        if (!this.account || permission.length==0) {
          this.$message({
            type:'warning',
            message:'error'
          })
          return;
        }


        this.$http.post('/api/v2.1/account_manage/add', {
          data:[
            {
              account:this.account,
              param:{
                permission: permission
              }
            }
          ],
          role:'AccountAdmin',
          permission:'AccountAdmin'
        }).then(function (res) {
          let error=res.body.error;

          if (error) {
            this.$message.error('code:'+error)
          } else {
            let result=res.body.result;
            if (result) {
              let resError=result[0].error
              if (resError) {
                //this.$message.error('code:'+resError)
                this.$message.error('Account is not found.')
                return;
              }
            }
            this.$message({
              type:'success',
              message:'Account has already been added'
            })
            this.$router.push('/accountsadmin_super')
          }
        }, function (err) {
          
        })
      },
      navToHome () {
        this.$router.push('/accountsadmin_super')
      }
    },
  }
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
    min-height:689px;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }

  .container .center .nav-bar span{
    cursor: pointer;
  }

  .container .center .content {
    margin-top:40px;
    padding-left: 8%;
    font-size:14px;
  }

  .container .center .content .text {
    margin:10px 0;
  }

  .container .center .content .check {
    margin-top:10px;
  }

  .container .center .content .check input {
    float: left;
  }
  .container .center .content .check span {
    float: left;
    margin-left:10px;
  }

  .container .center .content .email input{
    height:24px;
    width:300px;
    font-size:16px;
  }

  .container .center .content input[type="checkbox"] {
    /*width:18px;*/
    /*height:18px;*/

    width: 18px;
    height: 18px;
    /*background-color: #fff;*/
    /*-webkit-appearance:none;*/
    border: 1px solid #c9c9c9;
    border-radius: 2px;
    outline: none;
  }

  .container .center .content input[type="checkbox"]:checked {
    /*background: url("/static/accountadmin/icon_selected.png") no-repeat center;*/
  }

  .container .center .no-data {
    padding-top: 5%;
  }

  .container .center .no-data .text {
    text-align: center;
    font-size:20px;
    *margin-top: 20%;
  }

  .container .center .add-btn {
    width:150px;
    background-color:#0c544f;
    height:30px;
    border-radius:20px;
    /*margin: 0 auto;*/
    margin-top:30px;
    cursor: pointer;
  }

  .container .center .add-btn {
    color: #fff;
    text-align: center;
    line-height: 30px;
  }



</style>



// WEBPACK FOOTER //
// AccountAdminSuperAdd.vue?347dd21e